import classnames from 'classnames';
import React, { Ref } from 'react';

import { ErrorMessages } from 'common/components/Form/ErrorMessages';

type Props = {
  CaptchaRef?: Ref<HTMLDivElement>;
  error: boolean;
  errorMessage: string;
};

const CaptchaField = ({ CaptchaRef, error, errorMessage }: Props) => {
  const captchaFieldClass = classnames('captcha-field', { error: error });

  return (
    <div className={captchaFieldClass}>
      <div className="g-recaptcha" ref={CaptchaRef} />
      {error ? (
        <ErrorMessages
          messages={[errorMessage]}
          className="input-error-message"
        />
      ) : null}
    </div>
  );
};

// eslint-disable-next-line react/no-multi-comp
export default React.forwardRef<HTMLDivElement, Props>((props, ref) => (
  <CaptchaField {...props} CaptchaRef={ref} />
));
